import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import { getAbilitiesForRole, syncStoredStaffAbilities } from './staffAbilities'

const syncedAbility = syncStoredStaffAbilities()
const userData = typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('userData') || 'null') : null
const existingAbility = syncedAbility || (userData?.role ? getAbilitiesForRole(userData.role) : null) || (userData ? userData.ability : null)

export default new Ability(existingAbility || initialAbility)
